export enum ValidationRulesSearchStatus{
    ErrorOccured = -1,
    Created = 0,
    CSV_Loading = 1,
    CSV_Loaded = 2,
    Docs_Loading = 3,
    Docs_Loaded = 4,
    Text_Extracting = 5,
    Text_Extracted = 6,
    Search_Phrases = 9,
    Phrases_Found = 10,
    Search_Attributes = 11,
    Attributes_Found = 12
}

export type Category = { cat_id: number, cat_num: number, manufacturer: string, prod_type: string, last_update_date: string, status: ValidationRulesSearchStatus };
export type PhraseSet = { common_for: string[], phrases: string[] };
export type DocType = 'specSheet'|'warrantySheet'|'maintenanceSheet'|'installationSheet'|'msdsSheet';
export type DocPhraseSets = { doc_type: DocType, phrase_sets: PhraseSet[] };
export type Phrases = { result: DocPhraseSets[] };
export type CommonAttribute = { attribute: string, common_for: string[] };
export type DocAttributes = { doc_type: DocType, attributes: CommonAttribute[] };
export type Attributes = { result: DocAttributes[] };
export type PhraseTestResult = { phrase: string, common_for: string[], absent_in: string[] };
export type DocPhraseTestResult = { doc_type: DocType, phrase: PhraseTestResult };

export type GetCategoriesResp = { curr_categories: Category[], errorCode?: number };
export type CreateCategoryResp = { success: boolean, message: string, curr_categories?: Category[], errorCode?: number };
export type PerformStepForCategoryResp = { success: boolean, status: ValidationRulesSearchStatus, long_running: boolean, errorCode?: number };
export type GetCategoryPhrasesResp = { success: boolean, phrases?: Phrases, errorCode?: number };
export type GetCategoryAttributesResp = { success: boolean, attributes?: Attributes, errorCode?: number };
export type TestPhraseResp = { success: boolean, message: string, result?: DocPhraseTestResult[], errorCode?: number };
